// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1i9V6","bigColWidth":"Table_bigColWidth__3uwxz","biggerColWidth":"Table_biggerColWidth__Iy-6s","row":"Table_row__YLzbF","col":"Table_col__2ZW_t"};